import React, { useState } from 'react'

import { Form } from '../../../../components/Form/Form'
import Select from '../../../../components/Select/Select'
import SelectItem from '../../../../components/Select/SelectItem'
import TextField from '../../../../components/TextField/TextField'
import t from '../../../../helpers/i18n'

const numberValidation = (text) =>
  /^[1-9][0-9]*$/.test(text) ? false : t('validations.number_is_invalid')

const NewCompetitionStepFour = ({ divisions, data, setFormValid }) => {
  const [format, setFormat] = useState()

  return (
    <div>
      <h3>{t('titles.New_competition_Regular_Phase_Settings')}</h3>
      <Form data={data} onValidityChange={setFormValid}>
        <Select label={t('labels.Rounds')} required>
          <SelectItem>- {t('select_item.Select_rounds')} -</SelectItem>
          <SelectItem value='one'>{t('select_item.One round')}</SelectItem>
          <SelectItem value='two'>
            {t('select_item.Two_rounds_(home & away matches)')}
          </SelectItem>
        </Select>

        <h4>{t('titles.Format')}</h4>
        <Select
          label={t('labels.Format')}
          onChange={(value) => setFormat(value)}
          required
        >
          <SelectItem>- {t('select_item.Select_a_format')} -</SelectItem>
          <SelectItem value='groups'>{t('select_item.Groups')}</SelectItem>
          <SelectItem value='general'>{t('select_item.General Standing')}</SelectItem>
        </Select>

        {format === 'groups' && (
          <div>
            <TextField
              name='teams_per_group'
              label={t('labels.Amount_of_teams_per_group')}
              maxLength={3}
              minLength={1}
              onValidation={numberValidation}
              required
            />
            <Select name='assign_team' label={t('labels.Assign_teams')} required>
              <SelectItem value='all'>{t('select_item.Manual')}</SelectItem>
              <SelectItem value='tie'>{t('select_item.Random')}</SelectItem>
            </Select>
            <Select
              name='match_structure'
              label={t('labels.Match_structure')}
              required
            >
              <SelectItem value='all'>{t('select_item.All against')}</SelectItem>
              <SelectItem value='tie'>{t('select_item.Only within the group')}</SelectItem>
              <SelectItem value='tie'>{t('select_item.Custom')}</SelectItem>
            </Select>
          </div>
        )}

        <h4>{t('titles.Positions Tie Break Criteria')}</h4>
        {Array(6)
          .fill(0)
          .map((_, index) => (
            <Select key={index} label={t('labels.Criteria ') + (index + 1)} required>
              <SelectItem value=''>- {t('select_item.Not_set')} -</SelectItem>
              <SelectItem value='goals_difference'>
                {t('select_item.Goals_difference')}
              </SelectItem>
              <SelectItem value='goals_favor'>{t('select_item.Goals_in_favor')}</SelectItem>
              <SelectItem value='goals_against'>
                {t('select_item.Goals_against')}
              </SelectItem>
              <SelectItem value='match'>{t('select_item.Direct_match_results')}</SelectItem>
              <SelectItem value='fairplay'>{t('select_item.FairPlay')}</SelectItem>
              <SelectItem value='random'>{t('select_item.Random')}</SelectItem>
            </Select>
          ))}
      </Form>
    </div>
  )
}

export default NewCompetitionStepFour
